import React, { useState } from 'react';
import {} from 'reactstrap';
import PageBreadcrumb from '../../../Components/Common/PageBreadcrumb';
import '../../TenderOpening/components/TenderOpening.css';
import ProductHydro from './ProductHydro';

// This page lists Product Hydro procurements only (ProcurementTypeHeader = 1).
// The header itself is fixed inside ./ProductHydro.

const TenderEval = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{
                  label: 'Tender Evaluation',
                  to: '/apps-tenderevaluation/view',
                }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-scales-3-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>Tender Evaluation</h4>
                  <p className='to-hero-subtitle'>
                    Evaluate submitted offers per procurement and follow each
                    one from ready, to under evaluation.
                  </p>
                </div>
                <button
                  type='button'
                  className='to-hero-btn'
                  onClick={handleRefresh}
                >
                  <i className='ri-refresh-line' aria-hidden='true' />
                  Refresh
                </button>
              </div>
            </div>

            <ProductHydro
              refreshTrigger={refreshTrigger}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(TenderEval);
